// Use process on development and window on production
const useWindowVariables =
  process.env.NODE_ENV === 'production' && typeof window !== 'undefined'

export const config = {
  iamBaseUrl: useWindowVariables
    ? window.env.GATSBY_API_IAM_BASE_URL
    : process.env.GATSBY_API_IAM_BASE_URL,
  dodoBaseApiURL: useWindowVariables
    ? window.env.GATSBY_API_DODO_BASE_URL
    : process.env.GATSBY_API_DODO_BASE_URL,
  loginPortalURL: useWindowVariables
    ? window.env.GATSBY_LOGIN_PORTAL
    : process.env.GATSBY_LOGIN_PORTAL,
  dodoDashboardBaseURL: useWindowVariables
    ? window.env.GATSBY_DODO_DASHBOARD_BASE_URL
    : process.env.GATSBY_DODO_DASHBOARD_BASE_URL,
  gtmContainer: useWindowVariables
    ? window.env.GATSBY_GTM_CONTAINER
    : process.env.GATSBY_GTM_CONTAINER,
  gtmRequireConsent:
    (useWindowVariables
      ? window.env.GATSBY_GTM_REQUIRE_CONSENT
      : process.env.GATSBY_GTM_REQUIRE_CONSENT) === 'true',
  iamLoginBaseUrl: useWindowVariables
    ? window.env.GATSBY_API_IAM_LOGIN_BASE_URL
    : process.env.GATSBY_API_IAM_LOGIN_BASE_URL,
  loginEnabled:
    (useWindowVariables
      ? window.env.GATSBY_FF_LOGIN_ENABLED
      : process.env.GATSBY_FF_LOGIN_ENABLED) === 'true',
  loginUrlTemplate: useWindowVariables
    ? window.env.GATSBY_ARARA_LOGIN_URL_TEMPLATE
    : process.env.GATSBY_ARARA_LOGIN_URL_TEMPLATE,
  sentryDSN: useWindowVariables
    ? window.env.GATSBY_SENTRY_DSN
    : process.env.GATSBY_SENTRY_DSN,
  version: useWindowVariables
    ? window.env.APP_VERSION
    : process.env.APP_VERSION,
  env: useWindowVariables ? window.env.NODE_ENV : process.env.NODE_ENV,
  country: useWindowVariables ? window.env.COUNTRY : process.env.COUNTRY,
  isDhIamEnabled:
    (useWindowVariables
      ? window.env.GATSBY_FF_DH_IAM_ENABLED
      : process.env.GATSBY_FF_DH_IAM_ENABLED) === 'true',
}

export const allowedPublicEnvVariables = [
  'APP_VERSION',
  'DEPLOY_DATE_TIME',
  'NODE_ENV',
]

export const getPublicEnvironmentVariables = () =>
  Object.fromEntries(
    Object.entries(process.env).filter(
      ([key]) =>
        key.startsWith('GATSBY_') || allowedPublicEnvVariables.includes(key),
    ),
  )

export default config
